<template>
    <div class="card resource">
        <div v-if="resourceData" class="resource__content">

            <link-preview v-bind:resource="resource" v-bind:isEdit="isEdit" />

            <div v-if="!isEdit && hasTags" class="tags resource__tags">
                <a v-for="tag in resource.tagsSimple" :href="'/tag/' + slugifyTagName(tag)" class="tag is-light resource__tag">{{ tag }}</a>
            </div>

            <div v-if="isEdit" class="resource__edittags">
                <div class="field" is-grouped>
                    <!--<label class="label">Tags</label>-->
                    <div class="control">
                        <b-taginput
                            v-model="resource.tagsSimple"
                            :data="filteredTags"
                            placeholder="Add a tag"
                            :allow-new="true"
                            @typing="getFilteredTags"
                            :disabled="isUIDisabled"
                            >
                        </b-taginput>
                    </div>
                    <p class="help">Tags are all lowercase, and may contain only letters, numbers, hyphens (-) and colons (:).</p>
                </div>
            </div>
        </div>

        <resource-card-attribution
          :data="resourceData"
          :is-moderate="isEdit"
          :is-saving="isSaving"
          class="resource__attribution" />


        <div v-if="canEdit" class="dropdown is-right resource__menu" onclick="this.classList.toggle('is-active');">
            <div class="dropdown-trigger">
                <button class="button is-white" aria-haspopup="true">
                    <span class="icon is-small">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <a class="dropdown-item"
                      v-on:click="isEdit = true"
                      >Edit</a>
                </div>
            </div>
        </div>

        <div v-if="isSaved" class="card-content resource__actions resource__actions-saved">
            <div class="field is-grouped is-grouped-right">
              <p class="control">
                    Saved!
              </p>
            </div>
        </div>
        <div v-if="isEdit" class="card-content resource__actions">
            <div v-if="resourceData.approved_at" class="field is-grouped is-grouped-right">
              <p class="control">
                  <button
                      @click="approveResource"
                      class="button is-primary"
                      :class="{'is-loading': isSaving}"
                      :disabled="isUIDisabled || isDeleted || !hasTags">
                      Save
                  </button>
                  <button
                      @click="isEdit = false"
                      class="button is-text"
                      >
                      Cancel
                  </button>
              </p>
            </div>
            <div v-else-if="!resourceData.approved_at" class="field is-grouped is-grouped-right">
                <p class="control">
                    <button
                        v-if="!resourceData.approved_at"
                        @click="approveResource"
                        class="button is-primary"
                        :class="{'is-loading': isSaving}"
                        :disabled="isUIDisabled || isDeleted || !hasTags">
                        Approve
                    </button>

                    <button
                        v-if="resourceData.approved_at"
                        class="button is-text"
                        disabled>
                        Approved
                    </button>
                </p>

                <p class="control">
                    <button
                        v-if="!isDeleted"
                        @click="deleteResource"
                        class="button is-text"
                        :disabled="isUIDisabled">
                        Reject
                    </button>

                    <button
                        v-if="isDeleted"
                        class="button is-text"
                        disabled>
                        Rejected
                    </button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import ResourceCardAttribution from './ResourceCardAttribution';
import LinkPreview from './LinkPreview';
import Tag from '../../../../node_modules/buefy/src/components/tag/Tag'
import TagInput from 'buefy/src/components/taginput';
import axios from 'axios';
// import LinkPreview from './LinkPreview';

export default {
    props: {
        resource: { type: Object },
        canEdit: {
            type: Boolean,
            default: false
        },
        isEditing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            resourceData: this.resource,
            filteredTags: [],
            availableTags: {},
            isSaving: false,
            isDeleted: false,
            isUIDisabled: false,
            isEdit: false,
            isSaved: false,
        };
    },

    components: {
        'resource-card-attribution': ResourceCardAttribution,
        'link-preview': LinkPreview,
        'b-taginput': TagInput,
        'b-tag': Tag
        // 'link-preview': LinkPreview
    },

    created() {
        // pull the tag list that was bootstrapped into the page
        this.availableTags = window.AR.data.tags || {};
        this.isEdit = this.isEditing;
    },

    computed: {
        hasTags() {
            return this.resource.tagsSimple != null && this.resource.tagsSimple.length > 0;
        }
    },

    methods: {
        slugifyTagName(tag) {
            return tag.split(' ').join('-').toLowerCase();
        },

        getFilteredTags(text) {
            this.filteredTags = _.map(this.availableTags, item => item.name).filter((tag) => {
                return tag
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            });
        },

        approveResource() {
          this.isSaving = true;
          this.isUIDisabled = true;
          axios.post('/resource/approve/' + this.resource.id, {
                  tags: this.resource.tagsSimple,
                  title: this.resource.title,
                  insight: this.resource.insight,
              })
              .then(response => {
                  this.isSaving = false;
                  this.isSaved = true;
                  this.isEdit = false;
                  setTimeout(function(){this.isSaved = false;}.bind(this), 3000);
                  this.isUIDisabled = false;
                  if (response.data.success === true) {
                      this.resourceData.approved_at = new Date().getTime();
                      this.resourceData.approved = 1;
                      this.$emit('resource:approved', this.resourceData.id);
                  } else {
                      alert(response.data.message);
                  }
              });
        },
        deleteResource() {
            this.isUIDisabled = true;
            axios.post('/resource/delete/' + this.resourceData.id)
                .then(response => {
                    if (response.data.success === true) {
                        this.isUIDisabled = false;
                        this.isDeleted = 1;
                        this.$emit('resource:deleted', this.resourceData.id);
                    } else {
                        alert(response.data.message);
                    }
                });
        },

        save() {

        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ResourceCard.vue